module.exports = __webpack_public_path__ + "static/media/Room-4.02ec6b6f.jpg";